import { Box, IconButton, SelectField, TextField } from '@color/continuum';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import { omit } from 'lodash-es';
import { useState } from 'react';

interface FiltersProps {
  onChange: (filters: Record<string, string>) => void;
}

export const BrowsingFilters = ({ onChange }: FiltersProps) => {
  const [filtersMap, setFiltersMap] = useState<Record<string, string>>({});

  const handleInputChange = (filterName: string, value: string) => {
    const newMap = value ? { ...filtersMap, [filterName]: value } : omit(filtersMap, filterName);
    setFiltersMap(newMap);
    onChange(newMap);
  };

  const clearFilters = () => {
    setFiltersMap({});
    onChange({});
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: 1,
        padding: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          width: '100%',
        }}
      >
        <SelectField
          name="state"
          label=""
          helperText="State"
          optionalIndicatorIsEnabled={false}
          value={filtersMap.state || ''}
          options={[
            { label: 'All', value: '' },
            { label: 'New', value: 'new' },
            { label: 'Reviewed', value: 'reviewed' },
          ]}
          onChange={(e) => handleInputChange(e.target.name, (e.target.value as string) || '')}
        />
        {[
          ['Batch Name', 'sample_sequence_run__batch_label__icontains'],
          ['Sequence Name', 'sample_sequence_run__barcode__icontains'],
          ['Kit Barcode', 'sample_sequence_run__sample__kit_barcode__icontains'],
          ['Gene', 'gene__icontains'],
          ['CNV Class', 'cnv_class__icontains'],
          ['Exon Nomenclature', 'json_data__filtered_nomenclatures__icontains'],
        ].map(([label, filter]) => (
          <TextField
            label={label}
            name={filter}
            key={filter}
            value={filtersMap[filter] || ''}
            optionalIndicatorIsEnabled={false}
            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
          />
        ))}
      </Box>
      <IconButton size="small" title="Clear all filter" aria-label="Clear" onClick={clearFilters}>
        <FilterAltOffOutlinedIcon />
      </IconButton>
    </Box>
  );
};
